import { basicListAddEditDltInitialState } from '../../../../../stateManagement/reduxUtil';
import { licencesActionTypes } from '../actions/actionTypes';

const insertUpdateData = (action) => ({
  listData: action.data,
  listRequestError: null,
  listRequestProcessedOn: new Date(),
  loading: false,
});

const LicenceFilterReducer = (state = { ...basicListAddEditDltInitialState }, action = null) => {
  switch (action.type) {
    // reset Upset Value
    case licencesActionTypes.RESET_UPSERT_VALUE:
      return {
        ...state,
        upsertRequest: action.data.upsertRequest,
        upsertRequestError: action.data.upsertRequestError,
        upsertRequestedOn: action.data.upsertRequestedOn,
        upsertRequestProcessedOn: action.data.upsertRequestProcessedOn,
        upsertData: action.data.upsertData,
      };
    // reset Delete Value
    case licencesActionTypes.RESET_DELETE_VALUE:
      return {
        ...state,
        deleteRequest: action.data.deleteRequest,
        deleteRequestError: action.data.deleteRequestError,
        deleteRequestedOn: action.data.deleteRequestedOn,
        deleteRequestProcessedOn: action.data.deleteRequestProcessedOn,
        deleteData: action.data.deleteData,
      };
    case licencesActionTypes.GET_LICENCE_RESPONSE:
      return {
        ...state,
        ...insertUpdateData(action),
      };
    // Configure Page Details
    case licencesActionTypes.SET_LICENCE_DETAILS_RESPONSE:
      return {
        ...state,
        subModuledetails: action.data,
      };
    case licencesActionTypes.RESET_UPSERT_ERROR:
      return {
        ...state,
        upsertRequestError: [],
      };
    case licencesActionTypes.RESET_SERVER_VALUE:
      return {
        ...state,
        serverRequestError: action.data && action.data.serverRequestError,
      };

    case licencesActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };

    default:
      return state;
  }
};

export default LicenceFilterReducer;
